module.exports = __webpack_public_path__ + "img/bedroom1.40f9261f.png";